import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactHlsPlayer from "@ducanh2912/react-hls-player";
import api from '../../Utils/Api';
import '../MainPage/LeftColumn/LeftColumn.css';
import './Stream.css';
import logo from '../../Media/LogoOnly.png';

import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext';

import LeftColumn from '../MainPage/LeftColumn/LeftColumn';

const Stream = ({ courses }) => {
  const { setCurrentPlace } = useContext(JourneyContext);
  const { token, setUser, user } = useContext(CurrentUserContext);

  let params = useParams();
  let currentStreamId = parseInt(params.id);
  let curStream = [];
  const videoRef = useRef();

  const [stream, setStream] = useState(undefined);
  const [courseName, setcourseName] = useState(undefined);

  let sstream = [
    {
      id: 0,
      course_id: 12,
      group_id: 0,
      stream_url:
        'https://ia600300.us.archive.org/17/items/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4',
      start_date: 'string',
      end_date: 'string',
    },
  ];

  useEffect(() => {
    setCurrentPlace({ title: 'Онлайн трансляция' });
    Promise.all([api.getStreams(token)])
      .then(([stream]) => {
        if (currentStreamId !== 0) {
          curStream = stream?.filter((s) => {
            return s.id === currentStreamId;
          });
        } else {
          curStream.push(sstream[0]);
        }
        if (curStream?.length > 0) {
          setStream(curStream[0]);
          setcourseName(currentStreamCourseName(curStream));
          videoRef.current?.play();
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const currentStreamCourseName = (curStream) => {
    return courses?.filter((c) => {
      return c.id === curStream[0].course_id;
    })[0]?.title ?? '';
  };

  return (
    user && (
      <div className='stream__container'>
        <LeftColumn courses={courses} />
        <div className='stream__center'>
          <div className='stream__main'>
            {stream ? (
              <div className='stream__video'>
                <ReactHlsPlayer
                  playerRef={videoRef}
                  src={stream?.stream_url}
                  autoPlay={true}
                  controls={true}
                  width='100%'
                  height='auto'
                />

                <div className='overlayText'>
                  <p id='topText'> {courseName}</p>
                </div>
              </div>
            ) : (
              <div className='stream__nostream'>
                <img src={logo} alt='logo' />
                <div>Онлайн-трансляция сейчас не идет</div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};
export default Stream;
